import { render, staticRenderFns } from "./ResultadoPesquisaAccordion.vue?vue&type=template&id=2e3fa692&scoped=true&lang=pug"
import script from "./ResultadoPesquisaAccordion.vue?vue&type=script&lang=js"
export * from "./ResultadoPesquisaAccordion.vue?vue&type=script&lang=js"
import style0 from "./ResultadoPesquisaAccordion.vue?vue&type=style&index=0&id=2e3fa692&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3fa692",
  null
  
)

export default component.exports